import React, { useState, useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const SelectTipoCarga = ({ formik, field }) => {
  const [tipoCarga, setTipoCarga] = useState([]);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    request(apiRoutes.fiscalizacao.parametrizacao.consultaTipoCarga);
  }, [request]);

  useEffect(() => {
    if (data) setTipoCarga(data.result);

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          &nbsp;Carregando ...
        </span>
      ) : (
        <>
          <Form.Control
            as="select"
            id={field}
            name={field}
            disabled={formik.isSubmitting}
            value={formik.values[field]}
            onChange={formik.handleChange}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            <option key="0" value="">
              Selecione
            </option>
            {tipoCarga.map((item) => (
              <option key={item.sqTipoCarga} value={item.sqTipoCarga}>
                {item.nomeCarga}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default SelectTipoCarga;
